import { BellSimpleIcon } from '@phosphor-icons/react/dist/ssr';
import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import SidebarLayout, {
  SidebarLayoutContent,
  SidebarLayoutNavigation,
} from 'layouts/SidebarLayout';

const Posts: FC = () => {
  const tabs = [
    {
      key: 'syndicate-posts',
      label: 'Syndicate Posts',
      description: 'View information and updates from Syndicates',
      route: `/invest/posts`,
      icon: BellSimpleIcon,
      exact: true,
    },
    {
      key: 'fund-posts',
      label: 'Fund Posts',
      description: 'View information and updates from Funds',
      route: `/invest/posts/fund-posts`,
      icon: BellSimpleIcon,
    },
  ];

  return (
    <SidebarLayout>
      <SidebarLayoutNavigation
        title="Posts"
        subTitle="View information and updates from Syndicates and Funds"
      />
      <SidebarLayoutContent secondaryTabs={tabs}>
        <Outlet />
      </SidebarLayoutContent>
    </SidebarLayout>
  );
};

export default Posts;
